"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var utils_1 = require("../../../utils");
function isValueEqualToParsedDate(value, dateFormat) {
    var valueAsParsedDate = moment_1.default(value, dateFormat).format(dateFormat);
    return value === valueAsParsedDate;
}
function getDateFormat(value) {
    if (utils_1.DATE_REGEXP_WITH_DASH.test(value)) {
        return 'YYYY-MM-DD';
    }
    else if (utils_1.DATE_REGEXP_WITHOUT_DASH.test(value)) {
        return 'YYYYMMDD';
    }
    else if (utils_1.DATE_REGEXP_WITH_SLASH.test(value)) {
        return 'YYYY/MM/DD';
    }
    return undefined;
}
function getValidationFunc(verifyCalendarDate) {
    return function (value) {
        if (utils_1.isEmpty(value)) {
            return true;
        }
        var dateFormat = getDateFormat(value);
        if (dateFormat) {
            return verifyCalendarDate ? isValueEqualToParsedDate(value, dateFormat) : true;
        }
        return false;
    };
}
function formatter(value) {
    var dateFormat = getDateFormat(value);
    if (dateFormat !== undefined) {
        var date = moment_1.default(value, dateFormat);
        if (date.isValid()) {
            return date.format('YYYY-MM-DD');
        }
        else {
            return value;
        }
    }
    return value;
}
exports.dateValidator = {
    name: 'date',
    validation: getValidationFunc(true),
    formatter: formatter,
};
exports.dateFormatValidator = {
    name: 'dateFormat',
    validation: getValidationFunc(false),
    formatter: formatter,
};
//# sourceMappingURL=DateValidator.js.map